const resourceCenterPost = (WpTag = '') => `
  databaseId
  title
  date
  excerpt
  featuredImage {
    node {
      altText
      sourceUrl
      srcSet
    }
  }
  categories {
    nodes {
      slug
      name
    }
  }
  id
  slug
  tags {
    nodes {
      slug
      name
    }
  }
  content
  uri
  template {
    ... on ${WpTag}Template_ResourceCenterArticle {
      templateName
      resourceCenterPost {
        resourceCenterPostPostedBy
        resourceCenterPostRatingSource
      }
    }
  }
  seo {
    readingTime
  }
  template {
    ... on ${WpTag}Template_ResourceCenterArticle {
      resourceCenterPost {
        resourceCenterPostAverageRating
        resourceCenterPostSectionsBuilder {
          resourceCenterPostTypeBlock
          postsection2 {
            centerPostShowSectionLetsTalkForm
          }
          postsection1 {
            centerPostShowSectionSubscribeForm
          }
        }
      }
    }
  }
  seo {
    canonical
    cornerstone
    focuskw
    metaDesc
    metaKeywords
    metaRobotsNofollow
    metaRobotsNoindex
    opengraphAuthor
    opengraphDescription
    opengraphModifiedTime
    opengraphPublishedTime
    opengraphPublisher
    opengraphSiteName
    opengraphTitle
    opengraphType
    opengraphUrl
    readingTime
    title
    twitterDescription
    twitterTitle
    opengraphImage {
      sourceUrl
    }
    twitterImage {
      sourceUrl
    }
    breadcrumbs {
      text
      url
    }
    schema {
      articleType
      pageType
    }
  }
  language {
    code
    name
    locale
    slug
  }
`;

module.exports.resourceCenterPost = resourceCenterPost;
